import React, { useState, useContext } from 'react';
import RemoveDialog from '../../../Shared/Remove/RemoveDialog';
import { DELETE_INVITATION, SET_NOTIFICATION_MESSAGE, SET_NOTIFICATION_TYPE, SET_SELECTED_PROJECT_ID, TOGGLE_SHOW_NOTIFICATION, TOGGLE_SHOW_REJECT_INVITATION_DIALOG, UPDATE_INVITATION } from '../InvitationEvents';
import { useInvitation } from '../../../../Context/Invitation/InvitationContext';
import { rejectInvitation } from '../../../../API/Tenant/Tenant';
import { GlobalContext } from '../../../../Renderers/GlobalContext';
import { useTranslation } from 'react-i18next';

const RejectInvitationDialog = () => {

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    const [inProgress, setInProgress] = useState(false);
    const { subscription } = useContext(GlobalContext).state;
    const { state, dispatch } = useInvitation();
    const invitation = state.invitations
    const selectedProject = invitation.masterProjects.find(project => project.masterProjectId === state.selectedProjectId);
    const invitedByUser = state.invitations.invitedByUser || {};

    const handleClose = () => {
        dispatch({ type: SET_SELECTED_PROJECT_ID, payload: null });
        dispatch({ type: TOGGLE_SHOW_REJECT_INVITATION_DIALOG });
    }

    const handleRejectInvitation = async () => {
        if (!selectedProject || !invitation) return;
        setInProgress(true);
        try {
            const response = await rejectInvitation(invitation._id, selectedProject.masterProjectId, subscription._id);
            if (response._id) {
                dispatch({ type: UPDATE_INVITATION, payload: { id: selectedProject.masterProjectId, data: { status: "rejected" } } });
            } else {
                if (response.message) {
                    dispatch({ type: SET_NOTIFICATION_MESSAGE, payload: response.message });
                    dispatch({ type: TOGGLE_SHOW_NOTIFICATION });
                    dispatch({ type: SET_NOTIFICATION_TYPE, payload: "error" });
                    dispatch({ type: DELETE_INVITATION, payload: selectedProject.masterProjectId });
                } else {
                    dispatch({ type: SET_NOTIFICATION_MESSAGE, payload: "Failed to reject the invitation" });
                    dispatch({ type: TOGGLE_SHOW_NOTIFICATION });
                    dispatch({ type: SET_NOTIFICATION_TYPE, payload: "error" });
                    throw new Error("Failed to reject the invitation");
                }
            }
        } catch (error) {
            console.error("An error occurred while rejecting the invitation:", error);
        } finally {
            setInProgress(false);
            handleClose();
        }
    }

    if (!invitation) return null;

    return (
        <RemoveDialog
            showLoader={inProgress}
            Title={t("reject_invitation")}  
            toggleDeleteDialog={handleClose}
            message={t("reject_message")}
            message2={t("reject_message2", { appName: selectedProject.masterProject.name })}
            message3={t("reject_message3")}
            onDelete={handleRejectInvitation}
            onCancel={handleClose}
            deleteButtonText={t("reject_button")}
            cancelButtonText={t("cancel_button")}
        />
    );
}

export default RejectInvitationDialog;